import { numberInputAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe, defineStyle } from '@chakra-ui/react/styled-system';

import inputRecipe from '../recipes/Input.recipe';
import { rem } from '../themeUtils';

export const triggerSeparatorStyle = defineStyle({
  content: '""',
  position: 'absolute',
  top: '50%',
  left: '-1px',
  transform: 'translateY(-50%)',
  width: '1',
  height: '24',
  backgroundColor: 'border/minimal',
});

const triggerStyle = defineStyle({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flex: '1',
  userSelect: 'none',
  cursor: 'pointer',
  width: 'var(--stepper-width)',
  color: 'button/secondary/text',
  _disabled: {
    color: 'button/secondary/text-disabled',
    cursor: 'not-allowed',
  },
  _hover: {
    color: 'button/secondary/text-hover',
    backgroundColor: 'button/tertiary/bg-hover',
  },
  _active: {
    color: 'button/secondary/text-active',
    backgroundColor: 'button/tertiary/bg-active',
  },
});

export const numberInputSlotRecipe = defineSlotRecipe({
  className: 'number-input',
  slots: numberInputAnatomy.keys(),
  base: {
    root: {
      position: 'relative',
      zIndex: '0',
      isolation: 'isolate',
      '--control-width': rem(100),
    },
    input: {
      ...inputRecipe.base,
      verticalAlign: 'top',
      paddingInlineEnd: `var(--control-width) !important`,
    },
    control: {
      display: 'flex',
      gap: '1',
      position: 'absolute',
      top: 0,
      insetEnd: 0,
      margin: '1',
      height: 'calc(100% - 2px)',
      zIndex: '1',
    },
    incrementTrigger: {
      ...triggerStyle,
      borderTopEndRadius: '4',
      borderBottomEndRadius: '4',
      _before: triggerSeparatorStyle,
    },
    decrementTrigger: {
      ...triggerStyle,
    },
    valueText: {
      fontWeight: 'medium',
      fontFeatureSettings: 'pnum',
      fontVariantNumeric: 'proportional-nums',
    },
  },
  variants: {
    size: {
      md: {
        input: inputRecipe.variants?.size.md,
        control: {
          '--stepper-width': rem(40),
        },
      },
      lg: {
        input: inputRecipe.variants?.size.lg,
        control: {
          '--stepper-width': rem(48),
        },
      },
    },
  },

  defaultVariants: {
    size: 'lg',
  },
});

export default numberInputSlotRecipe;
